export const wabaOnboardingMutation = (builder) => ({
    wabaOnboarding: builder.mutation({
        query: (formData) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/waba_onboarding', // Adjusted to match your curl endpoint
                method: 'POST',
                body: formData, // Pass formData directly as the request body
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                },
            };
        },
    }),
});
